<template>
    <!-- NAVBAR SEARCH TRIGGER -->
    <div class="h-full" id="nav_searchbar">
        <div class="h-full block flex items-center justify-center px-6 cursor-pointer">
            <div ref="searchbar" v-mouse-gradient
                class="flex items-center px-2 md:px-4 bg-gray-100 dark:bg-neutral-800/50 rounded-full ring-1 !ring-black/10 dark:!ring-neutral-300/10 max-w-[400px] justify-between hover:scale-105 transition hover:shadow-lg hover:bg-gray-50 dark:hover:bg-neutral-700 active:scale-95"
                @click="openGeneralSearch">
                <svg xmlns="http://www.w3.org/2000/svg" class="w-4 h-4 pointer-events-none" fill="currentColor"
                    viewBox="0 0 512 512">
                    <path
                        d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z" />
                </svg>

                <div class="flex justify-center items-center min-w-24 lg:min-w-36 h-12 group max-w-[90%] ml-2 md:ml-4"
                    @click="openGeneralSearch">
                    <span v-if="singleWord" class="md3:hidden capitalize">
                        {{ $t('search') }}
                    </span>

                    <!-- On medium+ screens, show full text -->
                    <span class="hidden md3:inline capitalize">
                        {{ singleWord ? $t('search for') + ' ' + displayWords[0] : $t('Discover') }}
                    </span>
                    <span v-if="!singleWord" class="relative min-w-24 lg:min-w-36 h-12 overflow-hidden md3:ml-1">
                        <transition-group name="slide-fade" tag="div">
                            <div v-for="(word, index) in displayWords" :key="word + index"
                                class="absolute inset-0 shrink-0 flex items-center justify-start md3:text-primary-darkish dark:md3:text-primary select-none capitalize md3:normal-case w-max">
                                {{ word }} ...
                            </div>
                        </transition-group>
                    </span>
                </div>
            </div>
        </div>
        <general_searchbox_page></general_searchbox_page>
    </div>
</template>
  
<script>
export default {
    props: {
        listingType: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            words: [],
            currentIndex: 0,
            currentWord: '',
            interval: null,
            singleWord: false
        };
    },

    computed: {
        displayWords() {
            if (this.singleWord) {
                return [this.words[0]];
            }
            // if currentWord is empty, fallback to first word
            return [this.currentWord || this.words[0]];
        }
    },

    methods: {
        openGeneralSearch() {
            this.$root.$emit("showGeneralSearch", true);
        }
    },

    mounted() {
        // parse the comma-separated string
        this.words = this.listingType
            ? this.listingType.split(',').map(w => w.trim()).filter(Boolean)
            : ['hotels', 'events', 'restaurants'];

        this.singleWord = this.words.length === 1;

        this.currentWord = this.words[0];

        if (!this.singleWord && this.words.length > 1) {
            this.interval = setInterval(() => {
                let newIndex;
                do {
                    newIndex = Math.floor(Math.random() * this.words.length);
                } while (newIndex === this.currentIndex); // avoid repeating
                this.currentIndex = newIndex;
                this.currentWord = this.words[this.currentIndex];
            }, 2000);
        }
    },

    beforeDestroy() {
        clearInterval(this.interval);
    }
};
</script>
  
<style scoped>
.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.6s ease;
}

.slide-fade-enter {
    opacity: 0;
    transform: translateY(100%);
}

.slide-fade-leave-to {
    opacity: 0;
    transform: translateY(-100%);
}
</style>
  